(function () {
  const root = document.getElementById('gv-quick-order');
  if (!root) return;

  const listSelect = document.getElementById('qo-list-select');
  const listDropdown = document.getElementById('qo-list-dropdown');
  const listDropdownSummary = document.getElementById('qo-list-dropdown-summary');
  const listDropdownPanel = document.getElementById('qo-list-dropdown-panel');
  const manageListMenu = document.getElementById('qo-manage-list-menu');
  const tableSearchInput = document.getElementById('qo-table-search');
  const tableBody = document.getElementById('qo-table-body');
  const quickOrderTable = root.querySelector('.qo-table');
  const feedback = document.getElementById('qo-feedback');
  const bulkActionsMenu = document.getElementById('qo-bulk-actions');
  const bulkAddToCartButton = document.getElementById('qo-bulk-add-to-cart');
  const bulkRemoveFromListButton = document.getElementById('qo-bulk-remove-from-list');
  const selectAllToggle = document.getElementById('qo-select-all-toggle');
  const createListButton = document.getElementById('qo-create-list');
  const deleteListButton = document.getElementById('qo-delete-list');
  const setDefaultListButton = document.getElementById('qo-set-default-list');
  const createEmptyListButton = document.getElementById('qo-create-empty-list');
  const addItemButton = document.getElementById('qo-add-item');
  const addItemTopButton = document.getElementById('qo-add-item-top');
  const addItemModal = document.getElementById('qo-add-item-modal');
  const modalCloseButton = document.getElementById('qo-modal-close');
  const modalSearchInput = document.getElementById('qo-modal-search');
  const modalResults = document.getElementById('qo-modal-results');
  const modalAddSelectedButton = document.getElementById('qo-modal-add-selected');
  const defaultListModal = document.getElementById('qo-default-list-modal');
  const defaultModalCloseButton = document.getElementById('qo-default-modal-close');
  const modalSwitchListButton = document.getElementById('qo-modal-switch-list');
  const modalCreateListButton = document.getElementById('qo-modal-create-list');
  const inlineCreateListContainer = document.getElementById('qo-inline-create-list');
  const inlineCreateListNameInput = document.getElementById('qo-inline-create-list-name');
  const inlineCreateListConfirmButton = document.getElementById('qo-inline-create-list-confirm');
  const inlineCreateListCancelButton = document.getElementById('qo-inline-create-list-cancel');
  const listNameModal = document.getElementById('qo-list-name-modal');
  const listNameModalCloseButton = document.getElementById('qo-list-name-modal-close');
  const listNameInput = document.getElementById('qo-list-name-input');
  const listNameConfirmButton = document.getElementById('qo-list-name-confirm');
  const listNameCancelButton = document.getElementById('qo-list-name-cancel');
  let deleteListModal = document.getElementById('qo-delete-list-modal');
  let deleteListModalCloseButton = document.getElementById('qo-delete-list-modal-close');
  let deleteListCancelButton = document.getElementById('qo-delete-list-cancel');
  let deleteListConfirmButton = document.getElementById('qo-delete-list-confirm');
  let deleteListName = document.getElementById('qo-delete-list-name');

  const state = {
    quickOrder: null,
    quickOrderByLocation: [],
    locations: [],
    activeLocationIndex: 0,
    activeType: 'default',
    activeListId: null,
    activeListIsDefault: false,
    activeItems: [],
    variantMetaById: {},
    invalidVariantIds: {},
    modalItems: [],
    modalSearchRequestId: 0,
    modalSearchDebounceTimer: null,
    productJsonByHandle: {},
    tableSearchQuery: '',
    sortKey: null,
    sortDirection: 'asc',
    listOptions: [],
    cartQtyByVariantId: {},
    deleteListModalEventsBound: false,
    listDropdownFlashTimer: null,
    activeListRequestId: 0,
  };

  const apiBase = root.dataset.apiBase;
  const apiKey = root.dataset.apiKey;
  const shopifyCustomerId = root.dataset.shopifyCustomerId;
  const tableColumnCount = {
    default: 9,
    saved: 7,
  };

  function debugLog(label, payload) {
    try {
      if (payload === undefined) {
        console.log(`[gv-quick-order] ${label}`);
        return;
      }

      console.log(`[gv-quick-order] ${label}`, payload);
    } catch (error) {
      console.log(`[gv-quick-order] ${label}`);
    }
  }

  function setFeedback(message, isError) {
    if (!feedback) return;

    if (!isError) {
      feedback.textContent = '';
      feedback.style.color = '';
      return;
    }

    feedback.textContent = message || '';
    feedback.style.color = '#b00020';
  }

  function closeActionsMenu(exceptMenu = null) {
    root.querySelectorAll('.qo-actions-menu[open]').forEach((menu) => {
      if (menu !== exceptMenu) menu.removeAttribute('open');
    });
  }

  function bindExclusiveActionMenu(menu) {
    if (!menu) return;

    menu.addEventListener('toggle', function () {
      if (menu.open) closeActionsMenu(menu);
    });
  }

  function bindActionMenuDismissal() {
    [manageListMenu, listDropdown, bulkActionsMenu].forEach(bindExclusiveActionMenu);

    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      root.querySelectorAll('.qo-actions-menu[open]').forEach((menu) => {
        if (!menu.contains(target)) menu.removeAttribute('open');
      });
    });
  }

  function renderListDropdownSummaryContent(label, isDefaultBadge = false) {
    if (!listDropdownSummary) return;

    const summaryLabel = label || 'Select a list';
    const defaultBadgeMarkup = isDefaultBadge
      ? '<span class="qo-list-default-badge" aria-label="Default list">&#9733;</span>'
      : '';

    listDropdownSummary.innerHTML = `
      <span class="qo-list-dropdown__summary-text">${escapeHtml(summaryLabel)}</span>
      ${defaultBadgeMarkup}
      <span class="qo-list-dropdown__summary-caret" aria-hidden="true">▾</span>
    `;
  }

  function flashListDropdown(type = 'added') {
    if (!listDropdownSummary) return Promise.resolve();

    const className = type === 'removed' ? 'is-removed-feedback' : 'is-added-feedback';
    window.clearTimeout(state.listDropdownFlashTimer);
    listDropdownSummary.classList.remove('is-added-feedback', 'is-removed-feedback');
    void listDropdownSummary.offsetWidth;
    listDropdownSummary.classList.add(className);

    return new Promise((resolve) => {
      state.listDropdownFlashTimer = window.setTimeout(() => {
        listDropdownSummary.classList.remove(className);
        resolve();
      }, 1600);
    });
  }

  function getTrimmedValue(input) {
    return String(input?.value || '').trim();
  }

  function syncListActionAvailability() {
    const isDefaultListActive = state.activeType === 'default';
    const canSetDefaultList = state.activeType === 'saved' && state.activeListId && !state.activeListIsDefault;

    if (deleteListButton) {
      deleteListButton.disabled = false;
      deleteListButton.setAttribute('aria-disabled', isDefaultListActive ? 'true' : 'false');
    }

    if (setDefaultListButton) {
      setDefaultListButton.disabled = !canSetDefaultList;
      setDefaultListButton.setAttribute('aria-disabled', canSetDefaultList ? 'false' : 'true');
    }

    if (bulkRemoveFromListButton) {
      bulkRemoveFromListButton.hidden = isDefaultListActive;
    }
  }

  function getSelectedRowCount() {
    return getSelectedRows().length;
  }

  function syncBulkActionVisibility() {
    if (!bulkActionsMenu) return;
    const hasSelection = getSelectedRowCount() > 0;
    bulkActionsMenu.hidden = !hasSelection;
  }

  function getVisibleColumnCount() {
    return state.activeType === 'default' ? tableColumnCount.default : tableColumnCount.saved;
  }

  function renderLoadingRow(type = state.activeType) {
    const columnCount = type === 'default' ? tableColumnCount.default : tableColumnCount.saved;
    tableBody.innerHTML = `<tr><td class="qo-loading-cell" colspan="${columnCount}">Loading quick order...</td></tr>`;
    updateSelectAllToggleState();
    syncBulkActionVisibility();
  }

  function syncHistoryColumnVisibility() {
    root.classList.toggle('qo-show-history', state.activeType === 'default');
    root.classList.toggle('qo-hide-history', state.activeType !== 'default');
  }

  function setBusy(button, isBusy, busyText) {
    if (!button) return;
    const usesSpinner = button.classList.contains('qo-row-add');

    if (isBusy) {
      button.dataset.originalText = button.textContent;
      button.disabled = true;
      if (usesSpinner) {
        const width = button.getBoundingClientRect().width;
        if (width) button.style.width = `${width}px`;
        button.classList.add('is-loading');
        button.innerHTML = `
          <span class="qo-button-spinner" aria-hidden="true"></span>
          <span class="visually-hidden">${escapeHtml(busyText || 'Loading')}</span>
        `;
        return;
      }
      if (busyText) button.textContent = busyText;
    } else {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.style.width = '';
      if (button.dataset.originalText) {
        button.textContent = button.dataset.originalText;
        delete button.dataset.originalText;
      }
    }
  }

  function getActiveLocation() {
    return state.locations[state.activeLocationIndex] || null;
  }

  function getAccessParams(locationIndex = state.activeLocationIndex) {
    const location = state.locations[locationIndex];
    if (!location || !location.custId) {
      throw new Error('No customer location is available for this account.');
    }

    return {
      custId: location.custId,
      token: location.token || '',
      shopifyCustomerId,
    };
  }

  function buildUrl(path, params) {
    const url = new URL(`${apiBase}${path}`);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        url.searchParams.set(key, value);
      }
    });
    return url.toString();
  }

  function getUserFriendlyErrorMessage(rawErrorText, status) {
    const fallbackMessage = `Unable to complete that request right now. (${status})`;
    const trimmedErrorText = String(rawErrorText || '').trim();

    if (!trimmedErrorText) {
      console.error('[gv-quick-order] Empty API error response', { status });
      return fallbackMessage;
    }

    try {
      const parsedError = JSON.parse(trimmedErrorText);
      const userMessage =
        parsedError?.description || parsedError?.message || parsedError?.error || parsedError?.errors;

      console.error('[gv-quick-order] API request failed', {
        status,
        error: parsedError,
      });

      if (typeof userMessage === 'string' && userMessage.trim()) {
        return userMessage.trim();
      }
    } catch (error) {
      console.error('[gv-quick-order] Non-JSON API error response', {
        status,
        error: trimmedErrorText,
      });
    }

    if (!trimmedErrorText.startsWith('{') && !trimmedErrorText.startsWith('[') && !trimmedErrorText.startsWith('<')) {
      return trimmedErrorText;
    }

    return fallbackMessage;
  }

  async function apiFetch(path, method, params, body) {
    const response = await fetch(buildUrl(path, params), {
      method: method || 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-QuickOrder-ApiKey': apiKey,
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    if (response.status === 204) return null;

    if (!response.ok) {
      const text = await response.text();
      throw new Error(getUserFriendlyErrorMessage(text, response.status));
    }

    return response.json();
  }

  function isVariantUnavailableError(error) {
    const message = String(error?.message || '').toLowerCase();
    return (
      message.includes('variant is not available for this company location') ||
      message.includes('variant not found')
    );
  }

  function money(cents) {
    if (typeof cents !== 'number') return '—';
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD',
    });
  }

  function getCartItemVariantId(item) {
    return item?.variant_id ?? item?.variantId ?? item?.id;
  }

  function getInCartQuantity(variantId) {
    return state.cartQtyByVariantId[String(variantId)] || 0;
  }

  function setCartQuantitiesFromCart(cart) {
    const nextQuantities = {};

    (cart?.items || []).forEach((item) => {
      const variantId = getCartItemVariantId(item);
      if (!variantId) return;

      const key = String(variantId);
      nextQuantities[key] = (nextQuantities[key] || 0) + (Number(item.quantity) || 0);
    });

    state.cartQtyByVariantId = nextQuantities;
  }

  function incrementCartQuantities(items) {
    items.forEach((item) => {
      const variantId = item?.id ?? item?.variantId;
      if (!variantId) return;

      const key = String(variantId);
      state.cartQtyByVariantId[key] =
        (state.cartQtyByVariantId[key] || 0) + Math.max(1, Number(item.quantity) || 1);
    });
  }

  async function loadCartQuantities() {
    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) return;
      setCartQuantitiesFromCart(await response.json());
    } catch (error) {
      console.warn('Unable to load cart quantities', error);
    }
  }

  function updateInCartCells() {
    tableBody.querySelectorAll('[data-in-cart-variant-id]').forEach((cell) => {
      cell.textContent = String(getInCartQuantity(cell.dataset.inCartVariantId));
    });
  }

  async function loadVariantMeta(items) {
    const variantIds = [...new Set(items.map((item) => item.variantId).filter(Boolean))];
    const missing = variantIds.filter((id) => !state.variantMetaById[id] && !state.invalidVariantIds[id]);

    await Promise.all(
      missing.map(async (variantId) => {
        try {
          const response = await fetch(`/variants/${variantId}.js`);

          if (response.status === 404) {
            state.invalidVariantIds[variantId] = true;
            return;
          }

          if (!response.ok) return;

          const variant = await response.json();
          state.variantMetaById[variantId] = {
            price: variant.price,
            available: variant.available,
          };
        } catch (error) {
          console.warn('Variant meta fetch failed', variantId, error);
        }
      })
    );
  }

  function normalizeForMatch(value) {
    return String(value || '').trim().toLowerCase();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getTimesOrderedNumericValue(item) {
    const metrics = item.metrics;
    const value = metrics?.timesOrdered ?? metrics?.frequency;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : -1;
  }

  function getLastOrderedTimestamp(item) {
    const value = item.metrics?.lastOrderedAt;
    if (!value) return 0;
    const parsed = new Date(value);
    const timestamp = parsed.getTime();
    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  function compareItems(left, right) {
    if (!state.sortKey) return 0;

    const direction = state.sortDirection === 'desc' ? -1 : 1;
    let leftValue = '';
    let rightValue = '';

    if (state.sortKey === 'title') {
      leftValue = normalizeForMatch(left.productTitle);
      rightValue = normalizeForMatch(right.productTitle);
    } else if (state.sortKey === 'timesOrdered') {
      leftValue = getTimesOrderedNumericValue(left);
      rightValue = getTimesOrderedNumericValue(right);
    } else if (state.sortKey === 'lastOrdered') {
      leftValue = getLastOrderedTimestamp(left);
      rightValue = getLastOrderedTimestamp(right);
    } else if (state.sortKey === 'inCart') {
      leftValue = getInCartQuantity(left.variantId);
      rightValue = getInCartQuantity(right.variantId);
    }

    if (leftValue < rightValue) return -1 * direction;
    if (leftValue > rightValue) return 1 * direction;
    return 0;
  }

  function getRenderableItems() {
    const normalizedQuery = normalizeForMatch(state.tableSearchQuery);
    const filtered = (state.activeItems || []).filter((item) => {
      if (state.invalidVariantIds[item.variantId]) return false;
      if (!normalizedQuery) return true;

      const title = normalizeForMatch(item.productTitle);
      const sku = normalizeForMatch(item.sku);
      return title.includes(normalizedQuery) || sku.includes(normalizedQuery);
    });

    return filtered.sort(compareItems);
  }

  function getProductUrl(item) {
    if (!item.productHandle) return '#';
    return `/products/${item.productHandle}?variant=${item.variantId}`;
  }

  function formatLastOrderedDate(value) {
    if (!value) return '—';

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '—';

    return parsed.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  function getTimesOrderedValue(item) {
    const metrics = item.metrics;

    if (!metrics) return '—';

    return metrics.timesOrdered ?? metrics.frequency ?? '—';
  }

  function getLastOrderedValue(item) {
    return formatLastOrderedDate(item.metrics?.lastOrderedAt);
  }

  function rowTemplate(item) {
    const meta = state.variantMetaById[item.variantId] || {};
    const availability = meta.available === true ? 'In stock' : meta.available === false ? 'Unavailable' : '—';
    const displayVariantTitle =
        item.variantTitle && item.variantTitle !== 'Default Title'
          ? ` - ${item.variantTitle}`
          : '';

    return `
      <tr data-variant-id="${item.variantId}" data-item-id="${item.itemId || ''}">
        <td><input class="qo-row-select" type="checkbox" /></td>
        <td class="qo-col-product">
          <img src="${item.image || ''}" alt="${item.productTitle || 'Product'}" loading="lazy" />
          <div>
            <a class="qo-product-name qo-product-link" href="${getProductUrl(item)}">
              ${item.productTitle || 'Untitled product'}${displayVariantTitle}
            </a>
            <div class="qo-product-meta">${item.sku || '—'}</div>
          </div>
        </td>
        <td class="qo-history-cell qo-history-column">${getTimesOrderedValue(item)}</td>
        <td class="qo-history-cell qo-history-column">${getLastOrderedValue(item)}</td>
        <td>${availability}</td>
        <td class="qo-in-cart" data-in-cart-variant-id="${item.variantId}">${getInCartQuantity(item.variantId)}</td>
        <td class="qo-price">${money(meta.price)}</td>
        <td>
          <div class="qo-row-actions">
            <quantity-input class="quantity qo-row-quantity">
              <button class="quantity__button" name="minus" type="button">
                <span aria-hidden="true">−</span>
              </button>
              <input
                class="quantity__input qo-input-qty"
                type="number"
                min="1"
                value="${Math.max(1, item.quantity || 1)}"
                aria-label="Quantity for ${item.productTitle || 'product'}"
              />
              <button class="quantity__button" name="plus" type="button">
                <span aria-hidden="true">+</span>
              </button>
            </quantity-input>
            <button class="btn btn--outline qo-row-add" type="button">Add</button>
          </div>
        </td>
      </tr>
    `;
  }

  async function renderTable() {
    await loadVariantMeta(state.activeItems || []);

    const items = getRenderableItems();

    if (!items.length) {
      tableBody.innerHTML = `<tr><td colspan="${getVisibleColumnCount()}">No items found for this list.</td></tr>`;
      updateSelectAllToggleState();
      syncBulkActionVisibility();
      updateSortButtonStates();
      return;
    }

    syncHistoryColumnVisibility();
    tableBody.innerHTML = items.map(rowTemplate).join('');
    updateSelectAllToggleState();
    syncBulkActionVisibility();
    updateSortButtonStates();
  }

  function updateSortButtonStates() {
    if (!quickOrderTable) return;

    quickOrderTable.querySelectorAll('.qo-sort-button').forEach((button) => {
      const isActive = button.dataset.sortKey === state.sortKey;
      if (!isActive) {
        button.setAttribute('aria-sort', 'none');
        return;
      }

      button.setAttribute('aria-sort', state.sortDirection === 'desc' ? 'descending' : 'ascending');
    });
  }

  function renderListSelect() {
    const savedLocationIndex =
      state.quickOrderByLocation[state.activeLocationIndex] !== undefined ? state.activeLocationIndex : 0;
    const savedOptions = getDropdownSavedLists(savedLocationIndex).map((list) => {
      const isDefault = isSavedListDefault(list);
      return {
        value: `saved:${savedLocationIndex}:${list.id}`,
        label: list.name,
        isDefaultBadge: isDefault,
        optionType: 'saved',
      };
    });

    const defaultOptions = state.quickOrderByLocation.map((entry, locationIndex) => {
      const locationName = entry.location?.name || `Location ${locationIndex + 1}`;
      return {
        value: `default:${locationIndex}`,
        label: `Frequently Ordered - ${locationName}`,
        isDefaultBadge: false,
        optionType: 'default',
      };
    });

    const options = [...savedOptions, ...defaultOptions];
    state.listOptions = options;

    listSelect.innerHTML = options.map((opt) => `<option value="${opt.value}">${escapeHtml(opt.label)}</option>`).join('');
    renderCustomListDropdown();

    const activeSavedValue =
      state.activeType === 'saved' && state.activeListId !== null
        ? `saved:${state.activeLocationIndex}:${state.activeListId}`
        : null;
    const activeDefaultValue = `default:${state.activeLocationIndex}`;
    const hasActiveSavedOption = activeSavedValue && options.some((option) => option.value === activeSavedValue);

    if (hasActiveSavedOption) {
      listSelect.value = activeSavedValue;
      syncCustomListDropdownSelection();
      return;
    }

    const defaultSavedList = getSavedLists(state.activeLocationIndex).find((list) => isSavedListDefault(list));
    if (defaultSavedList) {
      const defaultSavedValue = `saved:${state.activeLocationIndex}:${defaultSavedList.id}`;
      if (options.some((option) => option.value === defaultSavedValue)) {
        listSelect.value = defaultSavedValue;
        syncCustomListDropdownSelection();
        return;
      }
    }

    listSelect.value = activeDefaultValue;
    syncCustomListDropdownSelection();
  }

  function renderCustomListDropdown() {
    if (!listDropdownPanel) return;

    const savedOptions = state.listOptions.filter((option) => option.optionType === 'saved');
    const defaultOptions = state.listOptions.filter((option) => option.optionType === 'default');
    const shouldRenderDivider = savedOptions.length > 0 && defaultOptions.length > 0;

    const savedMarkup = savedOptions
      .map((option) => `
        <button
          class="qo-actions-menu-item qo-list-dropdown-item"
          type="button"
          role="option"
          data-value="${escapeHtml(option.value)}"
          aria-selected="false"
        >
          <span class="qo-list-dropdown-item__content">
            <span>${escapeHtml(option.label)}</span>
            ${option.isDefaultBadge ? '<span class="qo-list-default-badge" aria-label="Default list">★</span>' : ''}
          </span>
        </button>
      `)
      .join('');

    const defaultMarkup = defaultOptions
      .map((option) => `
        <button
          class="qo-actions-menu-item qo-list-dropdown-item"
          type="button"
          role="option"
          data-value="${escapeHtml(option.value)}"
          aria-selected="false"
        >
          <span class="qo-list-dropdown-item__content">
            <span>${escapeHtml(option.label)}</span>
            ${option.isDefaultBadge ? '<span class="qo-list-default-badge" aria-label="Default list">★</span>' : ''}
          </span>
        </button>
      `)
      .join('');

    listDropdownPanel.innerHTML = `
      ${savedMarkup}
      ${shouldRenderDivider ? '<div class="qo-list-dropdown-divider" role="separator" aria-hidden="true"></div>' : ''}
      ${defaultMarkup}
    `;
  }

  function syncCustomListDropdownSelection() {
    if (!listDropdownPanel || !listDropdownSummary) return;

    const activeValue = listSelect?.value || '';
    const activeOption = state.listOptions.find((option) => option.value === activeValue);
    renderListDropdownSummaryContent(activeOption?.label, activeOption?.isDefaultBadge);

    listDropdownPanel.querySelectorAll('[data-value]').forEach((button) => {
      const isSelected = button.dataset.value === activeValue;
      button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
  }

  async function setActiveList(type, listId, locationIndex = state.activeLocationIndex) {
    const requestId = ++state.activeListRequestId;
    const isSavedList = type === 'saved' && listId;

    root.classList.add('qo-is-table-loading');
    state.activeLocationIndex = Number(locationIndex) || 0;
    state.activeType = isSavedList ? 'saved' : 'default';
    state.activeListId = isSavedList ? Number(listId) : null;
    state.activeListIsDefault = false;
    state.activeItems = [];
    syncListActionAvailability();
    syncHistoryColumnVisibility();
    renderLoadingRow(state.activeType);

    try {
      const params = getAccessParams(state.activeLocationIndex);
      const quickOrder = state.quickOrderByLocation[state.activeLocationIndex]?.quickOrder || {};

      if (isSavedList) {
        const detail = await apiFetch(`/lists/${listId}`, 'GET', params);
        if (requestId !== state.activeListRequestId) return;

        state.activeType = 'saved';
        state.activeListId = Number(listId);
        state.activeItems = detail.items || [];
        state.activeListIsDefault = isSavedListDefault(detail);
      } else {
        if (requestId !== state.activeListRequestId) return;

        state.activeType = 'default';
        state.activeListId = null;
        state.activeListIsDefault = false;
        state.activeItems = quickOrder.defaultList?.items || [];
      }

      syncListActionAvailability();
      syncHistoryColumnVisibility();

      await renderTable();
      if (requestId !== state.activeListRequestId) return;
    } finally {
      if (requestId === state.activeListRequestId) {
        root.classList.remove('qo-is-table-loading');
      }
    }
  }

  async function loadQuickOrder(preferredLocationIndex = state.activeLocationIndex) {
    setFeedback('', false);
    state.activeListRequestId += 1;
    root.classList.add('qo-is-table-loading');
    renderLoadingRow();

    try {
      state.quickOrderByLocation = await Promise.all(
        state.locations.map(async (location, locationIndex) => ({
          location,
          quickOrder: await apiFetch('', 'GET', getAccessParams(locationIndex)),
        }))
      );
      const safeLocationIndex = Math.min(
        Math.max(Number(preferredLocationIndex) || 0, 0),
        Math.max(state.quickOrderByLocation.length - 1, 0)
      );
      state.quickOrder = state.quickOrderByLocation[safeLocationIndex]?.quickOrder || null;
      state.activeType = 'default';
      state.activeListId = null;
      state.activeListIsDefault = false;
      state.activeLocationIndex = safeLocationIndex;

      await loadCartQuantities();

      const defaultSavedList = getSavedLists(safeLocationIndex).find((list) => isSavedListDefault(list));
      if (defaultSavedList?.id) {
        state.activeType = 'saved';
        state.activeListId = Number(defaultSavedList.id);
      }

      renderListSelect();
      if (defaultSavedList?.id) {
        await setActiveList('saved', defaultSavedList.id, safeLocationIndex);
      } else {
        await setActiveList('default', null, safeLocationIndex);
      }
      setFeedback('', false);
    } catch (error) {
      console.error(error);
      tableBody.innerHTML = `<tr><td colspan="${getVisibleColumnCount()}">${error.message}</td></tr>`;
      setFeedback(error.message, true);
      root.classList.remove('qo-is-table-loading');
    }
  }

  function isSavedListDefault(list) {
    return Boolean(list?.isDefault ?? list?.IsDefault);
  }

  function getSavedLists(locationIndex = state.activeLocationIndex) {
    return state.quickOrderByLocation[locationIndex]?.quickOrder?.savedLists || [];
  }

  function savedListNameExists(name, locationIndex = state.activeLocationIndex) {
    const normalizedName = String(name || '').trim().toLowerCase();
    if (!normalizedName) return false;

    return getSavedLists(locationIndex).some((list) => {
      const listName = String(list?.name || list?.Name || '').trim().toLowerCase();
      return listName === normalizedName;
    });
  }

  function getDropdownSavedLists(locationIndex = state.activeLocationIndex) {
    const savedLists = getSavedLists(locationIndex);
    if (!savedLists.length) return [];

    const defaultIndex = savedLists.findIndex((list) => isSavedListDefault(list));
    if (defaultIndex <= 0) return [...savedLists];

    const ordered = [...savedLists];
    const [defaultList] = ordered.splice(defaultIndex, 1);
    ordered.unshift(defaultList);
    return ordered;
  }

  function getSelectedSavedListContext() {
    if (state.activeType === 'saved' && state.activeListId) {
      return {
        listId: Number(state.activeListId),
        locationIndex: state.activeLocationIndex,
      };
    }

    const selectedValue = listSelect?.value || '';
    if (!selectedValue.startsWith('saved:')) return null;

    const [, locationIndex, listId] = selectedValue.split(':');
    if (!listId) return null;

    return {
      listId: Number(listId),
      locationIndex: Number(locationIndex) || 0,
    };
  }

  function getActiveSavedListName() {
    const context = getSelectedSavedListContext();
    const activeList = getSavedLists(context?.locationIndex ?? state.activeLocationIndex).find(
      (list) => String(list.id) === String(context?.listId)
    );
    return activeList?.name || 'this saved list';
  }

  function markSavedListAsDefault(listId, locationIndex = state.activeLocationIndex) {
    const savedLists = getSavedLists(locationIndex);
    if (!savedLists.length) return;

    savedLists.forEach((list) => {
      const isDefault = String(list.id) === String(listId);
      list.isDefault = isDefault;
      if ('IsDefault' in list) list.IsDefault = isDefault;
    });
  }

  async function setListAsDefault(listId, locationIndex = state.activeLocationIndex) {
    const params = getAccessParams(locationIndex);
    const detail = await apiFetch(`/lists/${listId}/default`, 'PUT', params);
    return detail;
  }

  async function ensureDefaultSavedList(locationIndex = state.activeLocationIndex, preferredListId = null) {
    const savedLists = getSavedLists(locationIndex);
    if (!savedLists.length) return null;

    const existingDefault = savedLists.find((list) => isSavedListDefault(list));
    if (existingDefault) {
      return { listId: Number(existingDefault.id), wasAssigned: false };
    }

    const fallbackList =
      savedLists.find((list) => String(list.id) === String(preferredListId)) ||
      savedLists[0];

    if (!fallbackList?.id) return null;

    await setListAsDefault(fallbackList.id, locationIndex);
    return { listId: Number(fallbackList.id), wasAssigned: true };
  }

  function getSelectedRows() {
    return Array.from(tableBody.querySelectorAll('tr')).filter((row) => {
      const checkbox = row.querySelector('.qo-row-select');
      return checkbox && checkbox.checked;
    });
  }

function updateCartBubbleCount(itemCount) {
  if (typeof itemCount !== 'number') return;

  const cartLinks = document.querySelectorAll('#cart-icon-bubble, #gv-header-cart #cart-icon-bubble');

  cartLinks.forEach((cartLink) => {
    let bubble = cartLink.querySelector('.cart-count-bubble');

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartLink.appendChild(bubble);
    }

    let visible = bubble.querySelector('span[aria-hidden="true"]');
    let hidden = bubble.querySelector('.visually-hidden');

    if (!visible) {
      visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      bubble.appendChild(visible);
    }

    if (!hidden) {
      hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      bubble.appendChild(hidden);
    }

    if (itemCount > 0) {
      visible.textContent = itemCount < 100 ? String(itemCount) : '99+';
      bubble.style.display = '';
      bubble.classList.remove('hidden', 'is-empty');
    } else {
      visible.textContent = '';
      bubble.style.display = 'none';
      bubble.classList.add('is-empty');
    }

    hidden.textContent = `${itemCount} item${itemCount === 1 ? '' : 's'}`;
  });
}

function updateCartUiFromSections(parsedState) {
  if (!parsedState) return;

  const iconSection = parsedState.sections && parsedState.sections['cart-icon-bubble'];
  if (iconSection) {
    const doc = new DOMParser().parseFromString(iconSection, 'text/html');

    const newCartLink =
      doc.querySelector('#cart-icon-bubble') ||
      doc.querySelector('#gv-header-cart #cart-icon-bubble');

    const currentCartLink =
      document.querySelector('#gv-header-cart #cart-icon-bubble') ||
      document.querySelector('#cart-icon-bubble');

    if (newCartLink && currentCartLink) {
      currentCartLink.innerHTML = newCartLink.innerHTML;
    }
  }

  updateCartBubbleCount(parsedState.item_count);

  const drawerSection = parsedState.sections && parsedState.sections['cart-drawer'];
  if (drawerSection) {
    const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (drawerInner) {
      const doc = new DOMParser().parseFromString(drawerSection, 'text/html');
      const replacementInner = doc.querySelector('.drawer__inner');
      if (replacementInner) {
        drawerInner.innerHTML = replacementInner.innerHTML;
        document.querySelector('cart-drawer')?.classList.toggle(
          'is-empty',
          (parsedState.items || []).length === 0
        );
      }
    }
  }
}

  async function addItemsToCart(items) {
    const activeLocation = getActiveLocation();
    const locationContext = {
      label: activeLocation?.name || null,
      custId: activeLocation?.custId || null,
      tokenPresent: Boolean(activeLocation?.token),
      shopifyCustomerId: shopifyCustomerId || null,
      cartItemCount: window.cartStrings?.item_count || null,
      pagePath: window.location.pathname,
    };

    debugLog('Attempting /cart/add.js request', {
      locationContext,
      items,
    });

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items,
        sections: ['cart-icon-bubble', 'cart-drawer'],
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) {
      const text = await response.text();
      debugLog('Cart add request failed', {
        status: response.status,
        statusText: response.statusText,
        responseText: text,
        locationContext,
        items,
      });
      throw new Error(text || 'Unable to add item to cart.');
    }

    const parsedState = await response.json();
    debugLog('Cart add request succeeded', {
      itemCount: parsedState?.item_count ?? null,
      itemKeys: (parsedState?.items || []).map((item) => item.key),
      locationContext,
      items,
    });
    updateCartUiFromSections(parsedState);
    incrementCartQuantities(items);
    updateInCartCells();
    await loadCartQuantities();
    updateInCartCells();
    return parsedState;
  }

  function markRowAdded(row) {
    row.classList.add('qo-row-added');
    setTimeout(() => {
      row.classList.remove('qo-row-added');
    }, 3000);
  }

  async function addSelectedRowsToCart() {
    const rows = getSelectedRows();
    if (!rows.length) {
      setFeedback('Select at least one item to add to cart.', true);
      return;
    }

    setBusy(bulkAddToCartButton, true, 'Adding...');

    try {
      const items = rows.map((row) => ({
        id: Number(row.dataset.variantId),
        quantity: Math.max(1, Number(row.querySelector('.qo-input-qty')?.value) || 1),
      }));
      await addItemsToCart(items);
      rows.forEach((row) => markRowAdded(row));
      setFeedback(`${rows.length} item(s) added to cart.`, false);
    } catch (error) {
      setFeedback(error.message, true);
    } finally {
      setBusy(bulkAddToCartButton, false);
    }
  }

  if (bulkAddToCartButton) {
    bulkAddToCartButton.addEventListener('click', async function () {
      closeActionsMenu();
      await addSelectedRowsToCart();
    });
  }

  function updateSelectAllToggleState() {
    if (!selectAllToggle) return;

    const checkboxes = tableBody.querySelectorAll('.qo-row-select');
    if (!checkboxes.length) {
      selectAllToggle.checked = false;
      selectAllToggle.indeterminate = false;
      return;
    }

    const checkedCount = Array.from(checkboxes).filter((checkbox) => checkbox.checked).length;
    selectAllToggle.checked = checkedCount === checkboxes.length;
    selectAllToggle.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length;
  }

  if (selectAllToggle) {
    selectAllToggle.addEventListener('change', function (event) {
      tableBody.querySelectorAll('.qo-row-select').forEach((checkbox) => {
        checkbox.checked = event.target.checked;
      });
      updateSelectAllToggleState();
      syncBulkActionVisibility();
    });
  }

  async function removeSelectedRowsFromList() {
    closeActionsMenu();
    if (state.activeType !== 'saved' || !state.activeListId) {
      setFeedback('Switch to a saved list to remove items.', true);
      return;
    }

    const rows = getSelectedRows().filter((row) => row.dataset.itemId);
    if (!rows.length) {
      setFeedback('Select at least one saved list item to remove.', true);
      return;
    }

    setBusy(bulkRemoveFromListButton, true, 'Removing...');

    try {
      for (const row of rows) {
        await apiFetch(`/lists/${state.activeListId}/items/${row.dataset.itemId}`, 'DELETE', getAccessParams());
      }
      await setActiveList('saved', state.activeListId);
      setFeedback(`${rows.length} item(s) removed from list.`, false);
    } catch (error) {
      setFeedback(error.message, true);
    } finally {
      setBusy(bulkRemoveFromListButton, false);
    }
  }

  if (bulkRemoveFromListButton) {
    bulkRemoveFromListButton.addEventListener('click', removeSelectedRowsFromList);
  }

  createListButton.addEventListener('click', async function () {
    closeActionsMenu();
    openListNameModal('copy');
  });

  if (deleteListButton) {
    deleteListButton.addEventListener('click', function () {
      closeActionsMenu();

      if (!getSelectedSavedListContext()) {
        setFeedback('Switch to a saved list to delete it.', true);
        return;
      }

      openDeleteListModal();
    });
  }

  createEmptyListButton.addEventListener('click', async function () {
    closeActionsMenu();
    openListNameModal('empty');
  });

  if (setDefaultListButton) {
    setDefaultListButton.addEventListener('click', async function () {
      closeActionsMenu();

      if (state.activeType !== 'saved' || !state.activeListId) {
        setFeedback('Switch to a saved list to set it as default.', true);
        return;
      }

      setBusy(setDefaultListButton, true, 'Saving...');
      try {
        await setListAsDefault(state.activeListId);
        markSavedListAsDefault(state.activeListId, state.activeLocationIndex);
        state.activeListIsDefault = true;
        syncListActionAvailability();
        renderListSelect();
        listSelect.value = `saved:${state.activeLocationIndex}:${state.activeListId}`;
        syncCustomListDropdownSelection();
        flashListDropdown();
        setFeedback('', false);
      } catch (error) {
        setFeedback(error.message, true);
      } finally {
        setBusy(setDefaultListButton, false);
      }
    });
  }


  function openAddItemModal() {
    if (!addItemModal || !modalResults || !modalSearchInput) return;

    state.modalItems = [];
    state.modalSearchRequestId += 1;

    addItemModal.hidden = false;
    addItemModal.classList.add('is-open');
    modalSearchInput.value = '';
    modalResults.innerHTML = '<p class="qo-modal__empty"></p>';
    modalSearchInput.focus();
  }

  function closeAddItemModal() {
    if (!addItemModal) return;
    addItemModal.hidden = true;
    addItemModal.classList.remove('is-open');
  }

  function openDefaultListModal() {
    if (!defaultListModal) return;
    resetInlineCreateList();
    defaultListModal.hidden = false;
    defaultListModal.classList.add('is-open');
  }

  function closeDefaultListModal() {
    if (!defaultListModal) return;
    resetInlineCreateList();
    defaultListModal.hidden = true;
    defaultListModal.classList.remove('is-open');
  }

  function openListNameModal(mode) {
    if (!listNameModal || !listNameInput) return;
    listNameModal.dataset.createMode = mode || 'empty';
    listNameInput.value = '';
    listNameModal.hidden = false;
    listNameModal.classList.add('is-open');
    listNameInput.focus();
  }

  function closeListNameModal() {
    if (!listNameModal || !listNameInput) return;
    listNameInput.value = '';
    listNameModal.hidden = true;
    listNameModal.classList.remove('is-open');
  }

  function bindDeleteListModalEvents() {
    if (!deleteListModal || state.deleteListModalEventsBound) return;

    deleteListModalCloseButton?.addEventListener('click', closeDeleteListModal);
    deleteListCancelButton?.addEventListener('click', closeDeleteListModal);
    deleteListConfirmButton?.addEventListener('click', deleteActiveList);
    bindModalDismiss(deleteListModal, closeDeleteListModal, '[data-delete-list-modal-close]');

    state.deleteListModalEventsBound = true;
  }

  function ensureDeleteListModal() {
    if (!deleteListModal) {
      const modalWrapper = document.createElement('div');
      modalWrapper.innerHTML = `
        <div id="qo-delete-list-modal" class="qo-modal" hidden>
          <div class="qo-modal__backdrop" data-delete-list-modal-close></div>
          <div class="qo-modal__dialog qo-modal__dialog--narrow" role="dialog" aria-modal="true" aria-labelledby="qo-delete-list-modal-title">
            <div class="qo-modal__header">
              <h2 id="qo-delete-list-modal-title" class="qo-modal__title">Delete list</h2>
              <button id="qo-delete-list-modal-close" class="qo-modal__close" type="button" aria-label="Close">&#10005;</button>
            </div>
            <div class="qo-modal__body">
              <p class="qo-modal__notice-copy">
                Delete <strong id="qo-delete-list-name">this saved list</strong>? This cannot be undone.
              </p>
            </div>
            <div class="qo-modal__footer">
              <button id="qo-delete-list-cancel" class="btn btn--outline" type="button">Cancel</button>
              <button id="qo-delete-list-confirm" class="btn btn--primary" type="button">Delete list</button>
            </div>
          </div>
        </div>
      `;

      (document.querySelector('.gv-quick-order-page') || document.body).appendChild(modalWrapper.firstElementChild);

      deleteListModal = document.getElementById('qo-delete-list-modal');
      deleteListModalCloseButton = document.getElementById('qo-delete-list-modal-close');
      deleteListCancelButton = document.getElementById('qo-delete-list-cancel');
      deleteListConfirmButton = document.getElementById('qo-delete-list-confirm');
      deleteListName = document.getElementById('qo-delete-list-name');
    }

    bindDeleteListModalEvents();
    return deleteListModal;
  }

  function openDeleteListModal() {
    if (!ensureDeleteListModal()) {
      setFeedback('Unable to open delete confirmation. Please try again.', true);
      return;
    }

    if (deleteListName) {
      deleteListName.textContent = getActiveSavedListName();
    }
    deleteListModal.hidden = false;
    deleteListModal.classList.add('is-open');
    deleteListConfirmButton?.focus();
  }

  function closeDeleteListModal() {
    if (!deleteListModal) return;
    deleteListModal.hidden = true;
    deleteListModal.classList.remove('is-open');
  }

  async function deleteActiveList() {
    const context = getSelectedSavedListContext();

    if (!context?.listId) {
      closeDeleteListModal();
      setFeedback('Switch to a saved list to delete it.', true);
      return;
    }

    const deletedListName = getActiveSavedListName();
    const deletedListWasDefault = state.activeListIsDefault;

    setBusy(deleteListConfirmButton, true, 'Deleting...');

    try {
      await apiFetch(`/lists/${context.listId}`, 'DELETE', getAccessParams(context.locationIndex));
      closeDeleteListModal();
      renderListDropdownSummaryContent(deletedListName, deletedListWasDefault);
      await flashListDropdown('removed');
      await loadQuickOrder(context.locationIndex);
      setFeedback('', false);
    } catch (error) {
      setFeedback(error.message, true);
    } finally {
      setBusy(deleteListConfirmButton, false);
    }
  }

  function showInlineCreateList() {
    if (!inlineCreateListContainer || !inlineCreateListNameInput) return;
    inlineCreateListContainer.hidden = false;
    inlineCreateListNameInput.value = '';
    inlineCreateListNameInput.focus();
  }

  function resetInlineCreateList() {
    if (!inlineCreateListContainer || !inlineCreateListNameInput) return;
    inlineCreateListContainer.hidden = true;
    inlineCreateListNameInput.value = '';
  }

  async function createListFlow(name, mode) {
    const trimmedName = String(name || '').trim();
    if (!trimmedName) {
      setFeedback('Enter a list name to continue.', true);
      return null;
    }

    if (savedListNameExists(trimmedName)) {
      setFeedback('A saved list with this name already exists.', true);
      return null;
    }

    const normalizedMode = mode === 'copy' ? 'copy' : 'empty';
    const hadNoSavedLists = getSavedLists().length === 0;
    const params = getAccessParams();
    const created = await apiFetch('/lists', 'POST', params, { name: trimmedName });
    let unavailableCount = 0;

    if (normalizedMode === 'copy') {
      const selectedRows = getSelectedRows();
      const rowsToSave = selectedRows.length ? selectedRows : Array.from(tableBody.querySelectorAll('tr'));

      for (const row of rowsToSave) {
        const variantId = Number(row.dataset.variantId);
        if (!variantId) continue;
        const qty = Number(row.querySelector('.qo-input-qty')?.value || 1);
        try {
          await apiFetch(`/lists/${created.id}/items`, 'POST', params, {
            variantId,
            quantity: qty,
          });
        } catch (error) {
          if (isVariantUnavailableError(error)) {
            unavailableCount += 1;
            continue;
          }
          throw error;
        }
      }

      if (unavailableCount > 0) {
        setFeedback(
          `${unavailableCount} item(s) could not be saved because they are not available.`,
          true
        );
      }
    }

    await loadQuickOrder();
    if (hadNoSavedLists) {
      await setListAsDefault(created.id);
      await loadQuickOrder();
    }
    await setActiveList('saved', created.id);
    renderListSelect();
    listSelect.value = `saved:${state.activeLocationIndex}:${created.id}`;

    if (unavailableCount > 0) {
      setFeedback(
        `${unavailableCount} item(s) could not be saved because they are not available.`,
        true
      );
    } else {
      setFeedback('', false);
    }

    flashListDropdown();
    return created;
  }

  async function searchModalItems(query) {
    const term = (query || '').trim();
    if (!term || term.length < 2) {
      state.modalItems = [];
      renderModalResults([]);
      modalResults.innerHTML = '<p class="qo-modal__empty"></p>';
      return;
    }

    const requestId = ++state.modalSearchRequestId;
    modalResults.innerHTML = '<p class="qo-modal__empty">Searching…</p>';

    try {
      const predictiveBaseUrl = window.routes?.predictive_search_url || '/search/suggest';
      const predictiveUrl = new URL(`${predictiveBaseUrl}.json`, window.location.origin);
      predictiveUrl.searchParams.set('q', term);
      predictiveUrl.searchParams.set('resources[type]', 'product');
      predictiveUrl.searchParams.set('resources[limit]', '10');
      predictiveUrl.searchParams.set('resources[options][unavailable_products]', 'hide');
      predictiveUrl.searchParams.set('resources[options][fields]', 'title,variants.title,variants.sku');

      const predictiveResponse = await fetch(predictiveUrl.toString(), {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!predictiveResponse.ok) {
        throw new Error('Unable to search products right now.');
      }

      const predictivePayload = await predictiveResponse.json();
      const predictiveProducts = predictivePayload?.resources?.results?.products || [];
      const normalizedTerm = normalizeForMatch(term);
      const matchedItems = [];

      for (const product of predictiveProducts) {
        if (!product?.handle) continue;

        let productJson = state.productJsonByHandle[product.handle];
        if (!productJson) {
          const productResponse = await fetch(`/products/${product.handle}.js`);
          if (!productResponse.ok) {
            continue;
          }
          productJson = await productResponse.json();
          state.productJsonByHandle[product.handle] = productJson;
        }

        const variants = productJson?.variants || [];
        const productImage = productJson?.images?.[0] || product?.featured_image?.url || '';
        const matchingVariants = variants.filter((variant) => {
          const haystack = [
            productJson?.title,
            variant?.title,
            variant?.sku,
          ]
            .map(normalizeForMatch)
            .join(' ');

          return haystack.includes(normalizedTerm);
        });

        const variantsToRender = matchingVariants.length ? matchingVariants : variants.slice(0, 1);

        variantsToRender.forEach((variant) => {
          if (!variant?.id) return;
          matchedItems.push({
            variantId: Number(variant.id),
            productTitle: productJson?.title || product?.title || 'Untitled product',
            variantTitle: variant.title || '',
            sku: variant.sku || '',
            image: productImage,
          });
        });
      }

      if (requestId !== state.modalSearchRequestId) return;

      state.modalItems = matchedItems.filter(
        (item, index, allItems) => allItems.findIndex((entry) => entry.variantId === item.variantId) === index
      );
      renderModalResults(state.modalItems);
    } catch (error) {
      if (requestId !== state.modalSearchRequestId) return;
      modalResults.innerHTML = `<p class="qo-modal__empty">${error.message}</p>`;
    }
  }

  function renderModalResults(items) {
    if (!modalResults) return;

    if (!items.length) {
      modalResults.innerHTML = '<p class="qo-modal__empty">No items found.</p>';
      return;
    }

    modalResults.innerHTML = items
      .map((item) => {
        const variantLabel = item.variantTitle && item.variantTitle !== 'Default Title' ? ` - ${item.variantTitle}` : '';
        return `
          <label class="qo-modal__result">
            <input class="qo-modal__select" type="checkbox" data-variant-id="${item.variantId}" />
            <img
              class="qo-modal__result-image"
              src="${item.image || ''}"
              alt="${escapeHtml(item.productTitle || 'Product')}"
              loading="lazy"
            />
            <span class="qo-modal__result-text">
              <strong>${escapeHtml(item.productTitle || 'Untitled product')}${escapeHtml(variantLabel)}</strong>
              <span>${escapeHtml(item.sku || 'No SKU')}</span>
            </span>
            <input class="qo-modal__qty" type="number" min="1" value="1" aria-label="Quantity for ${escapeHtml(item.productTitle || 'product')}" />
          </label>
        `;
      })
      .join('');
  }

  async function addSelectedModalItems() {
    const selectedRows = Array.from(modalResults.querySelectorAll('.qo-modal__result')).filter((entry) =>
      entry.querySelector('.qo-modal__select')?.checked
    );

    if (!selectedRows.length) {
      setFeedback('Select at least one item to add.', true);
      return;
    }

    setBusy(modalAddSelectedButton, true, 'Adding...');

    try {
      let addedCount = 0;
      let unavailableCount = 0;

      for (const entry of selectedRows) {
        const checkbox = entry.querySelector('.qo-modal__select');
        const qtyInput = entry.querySelector('.qo-modal__qty');
        try {
          await apiFetch(`/lists/${state.activeListId}/items`, 'POST', getAccessParams(), {
            variantId: Number(checkbox.dataset.variantId),
            quantity: Math.max(1, Number(qtyInput?.value) || 1),
          });
          addedCount += 1;
        } catch (error) {
          if (isVariantUnavailableError(error)) {
            unavailableCount += 1;
            continue;
          }
          throw error;
        }
      }

      await setActiveList('saved', state.activeListId);
      closeAddItemModal();

      if (!addedCount && unavailableCount) {
        setFeedback('Selected items are not available and were not saved.', true);
        return;
      }

      if (unavailableCount > 0) {
        setFeedback(
          `${addedCount} item(s) added. ${unavailableCount} item(s) were not available.`,
          true
        );
        return;
      }

      setFeedback(`${addedCount} item(s) added to list.`, false);
    } catch (error) {
      setFeedback(error.message, true);
    } finally {
      setBusy(modalAddSelectedButton, false);
    }
  }

  function handleAddItemButtonClick() {
    if (state.activeType !== 'saved' || !state.activeListId) {
      openDefaultListModal();
      return;
    }

    openAddItemModal();
  }

  if (addItemButton) {
    addItemButton.addEventListener('click', handleAddItemButtonClick);
  }

  if (addItemTopButton) {
    addItemTopButton.addEventListener('click', handleAddItemButtonClick);
  }

  if (modalCloseButton) {
    modalCloseButton.addEventListener('click', closeAddItemModal);
  }

  if (defaultModalCloseButton) {
    defaultModalCloseButton.addEventListener('click', closeDefaultListModal);
  }

  if (listNameModalCloseButton) {
    listNameModalCloseButton.addEventListener('click', closeListNameModal);
  }

  if (listNameCancelButton) {
    listNameCancelButton.addEventListener('click', closeListNameModal);
  }

  function bindModalDismiss(modal, closeModal, backdropSelector) {
    if (!modal) return;

    modal.addEventListener('click', function (event) {
      if (event.target.matches(backdropSelector) || !event.target.closest('.qo-modal__dialog')) {
        closeModal();
      }
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }

  bindModalDismiss(addItemModal, closeAddItemModal, '[data-modal-close]');
  bindModalDismiss(defaultListModal, closeDefaultListModal, '[data-default-modal-close]');
  bindModalDismiss(listNameModal, closeListNameModal, '[data-list-name-modal-close]');
  bindDeleteListModalEvents();

  document.addEventListener('click', function (event) {
    if (event.target.closest('.qo-actions-menu')) return;
    closeActionsMenu();
  });

  if (modalSearchInput) {
    modalSearchInput.addEventListener('input', function (event) {
      if (state.modalSearchDebounceTimer) {
        window.clearTimeout(state.modalSearchDebounceTimer);
      }

      state.modalSearchDebounceTimer = window.setTimeout(() => {
        searchModalItems(event.target.value || '');
      }, 250);
    });
  }

  if (modalAddSelectedButton) {
    modalAddSelectedButton.addEventListener('click', addSelectedModalItems);
  }

  if (modalSwitchListButton) {
    modalSwitchListButton.addEventListener('click', async function () {
      const locationIndex = state.activeLocationIndex;
      const savedLists = getSavedLists(locationIndex);
      if (!savedLists.length) {
        setFeedback('No saved list found. Create a new list to continue.', true);
        return;
      }

      try {
        const defaultResult = await ensureDefaultSavedList(locationIndex);
        if (!defaultResult?.listId) {
          setFeedback('No saved list found. Create a new list to continue.', true);
          return;
        }

        if (defaultResult.wasAssigned) {
          await loadQuickOrder(locationIndex);
        }

        const defaultOptionValue = `saved:${locationIndex}:${defaultResult.listId}`;
        listSelect.value = defaultOptionValue;
        listSelect.dispatchEvent(new Event('change'));
        closeDefaultListModal();
        setFeedback(
          defaultResult.wasAssigned
            ? 'No default list was set, so we set one and switched to it.'
            : 'Switched to your default saved list. You can now add items.',
          false
        );
      } catch (error) {
        setFeedback(error.message, true);
      }
    });
  }

  if (modalCreateListButton) {
    modalCreateListButton.addEventListener('click', function () {
      showInlineCreateList();
    });
  }

  if (inlineCreateListCancelButton) {
    inlineCreateListCancelButton.addEventListener('click', resetInlineCreateList);
  }

  if (inlineCreateListConfirmButton) {
    inlineCreateListConfirmButton.addEventListener('click', async function () {
      setBusy(inlineCreateListConfirmButton, true, 'Creating...');
      try {
        const created = await createListFlow(getTrimmedValue(inlineCreateListNameInput), 'empty');
        if (!created) return;
        closeDefaultListModal();
        setFeedback('New list created. You can now add items.', false);
      } catch (error) {
        setFeedback(error.message, true);
      } finally {
        setBusy(inlineCreateListConfirmButton, false);
      }
    });
  }

  if (listNameConfirmButton) {
    listNameConfirmButton.addEventListener('click', async function () {
      setBusy(listNameConfirmButton, true, 'Creating...');
      try {
        const mode = listNameModal?.dataset?.createMode || 'empty';
        const created = await createListFlow(getTrimmedValue(listNameInput), mode);
        if (!created) return;
        closeListNameModal();
      } catch (error) {
        setFeedback(error.message, true);
      } finally {
        setBusy(listNameConfirmButton, false);
      }
    });
  }

  if (tableSearchInput) {
    tableSearchInput.addEventListener('input', async function (event) {
      state.tableSearchQuery = event.target.value || '';
      await renderTable();
    });
  }

  if (quickOrderTable) {
    quickOrderTable.addEventListener('click', async function (event) {
      const sortButton = event.target.closest('.qo-sort-button');
      if (!sortButton) return;

      const nextSortKey = sortButton.dataset.sortKey;
      if (!nextSortKey) return;

      if (state.sortKey === nextSortKey) {
        state.sortDirection = state.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        state.sortKey = nextSortKey;
        state.sortDirection = nextSortKey === 'inCart' ? 'desc' : 'asc';
      }

      await renderTable();
    });
  }

  listSelect.addEventListener('change', async function (event) {
    const value = event.target.value;
    syncCustomListDropdownSelection();
    if (value.startsWith('saved:')) {
      const [, locationIndex, listId] = value.split(':');
      await setActiveList('saved', listId, locationIndex);
    } else {
      const [, locationIndex] = value.split(':');
      await setActiveList('default', null, locationIndex);
    }
  });

  if (listDropdownPanel) {
    listDropdownPanel.addEventListener('click', function (event) {
      const optionButton = event.target.closest('.qo-list-dropdown-item');
      if (!optionButton || !listSelect) return;

      const nextValue = optionButton.dataset.value;
      if (!nextValue || nextValue === listSelect.value) {
        if (listDropdown) listDropdown.removeAttribute('open');
        return;
      }

      listSelect.value = nextValue;
      listSelect.dispatchEvent(new Event('change'));
      if (listDropdown) listDropdown.removeAttribute('open');
    });
  }

  tableBody.addEventListener('click', async function (event) {
    const row = event.target.closest('tr');
    if (!row) return;

    if (event.target.classList.contains('qo-row-add')) {
      const addButton = event.target;
      setBusy(addButton, true, 'Adding...');
      try {
        const qty = Math.max(1, Number(row.querySelector('.qo-input-qty')?.value) || 1);
        await addItemsToCart([{ id: Number(row.dataset.variantId), quantity: qty }]);
        markRowAdded(row);
        setFeedback('Item added to cart.', false);
      } catch (error) {
        setFeedback(error.message, true);
      } finally {
        setBusy(addButton, false);
      }
    }

  });

  tableBody.addEventListener('change', function (event) {
    if (event.target.classList.contains('qo-row-select')) {
      updateSelectAllToggleState();
      syncBulkActionVisibility();
    }
  });

  bindActionMenuDismissal();

  tableBody.addEventListener('change', async function (event) {
    if (!event.target.classList.contains('qo-input-qty')) return;

    const row = event.target.closest('tr');
    if (!row) return;

    const item = state.activeItems.find((entry) => String(entry.variantId) === String(row.dataset.variantId));
    if (item) {
      item.quantity = Math.max(1, Number(event.target.value) || 1);
    }

    await renderTable();

    if (state.activeType === 'saved' && state.activeListId && row.dataset.itemId) {
      try {
        await apiFetch(`/lists/${state.activeListId}/items/${row.dataset.itemId}`, 'PUT', getAccessParams(), {
          quantity: Math.max(1, Number(event.target.value) || 1),
        });
      } catch (error) {
        setFeedback(error.message, true);
      }
    }
  });

  try {
    state.locations = JSON.parse(root.dataset.locations || '[]').filter((location) => location?.custId);
  } catch (error) {
    console.error('Unable to parse quick order locations', error);
    state.locations = [];
  }

  if (!state.locations.length) {
    tableBody.innerHTML = `<tr><td colspan="${getVisibleColumnCount()}">No customer location is available for this account.</td></tr>`;
    setFeedback('No customer location is available for this account.', true);
    return;
  }

  loadQuickOrder();
})();
